import React from "react";
var __jsx = React.createElement;
import StepsContainer from "@/pages/module-sell-trade/components/StepsContainer";
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
var PriceOfferProgressBar = function PriceOfferProgressBar() {
  var _usePriceOfferContext = usePriceOfferContext(),
    progressSteps = _usePriceOfferContext.progressSteps,
    progressPercentage = _usePriceOfferContext.progressPercentage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StepsContainer, {
    steps: progressSteps,
    percentage: progressPercentage,
    titleContainerClassname: "!justify-evenly"
  }));
};
export default PriceOfferProgressBar;